<template>
    <template v-if="!$store.state.waitingRequest">
        <main>
            <h1 v-if="libelle == 'Clickers'">Jeux de {{ libelle }} <i class='fas fa-mouse'></i></h1>
            <h1 v-if="libelle == 'Réflexion'">Jeux de {{ libelle }} <i class="fas fa-search"></i></h1>
            <h1 v-if="libelle == 'Action'">Jeux d'{{ libelle }} <i class="fas fa-bomb"></i></h1>
            <h1 v-if="libelle == 'Course'">Jeux de {{ libelle }} <i class="fas fa-car"></i></h1>
            
            <p class="gamesNumber">Découvres-y {{ lesJeux.length }} jeux ! <i></i></p>
            
            <section>
                <div class="all-games">
                    <div class="jeu-container" v-for="unJeu in lesJeux" :key="unJeu.id">
                        <div class="jeu">
                            <div class="ribbon-new-container" v-if="(((nowDate - (new Date(unJeu.created_at.replace(/-/g, '/')).getTime()/1000))/3600).toFixed(2)) <= 72.00">
                                <div class="ribbon-new">NOUVEAU</div>
                            </div>
                            
                            <router-link :to="'/' + unJeu.title_url" :title="unJeu.title">
                                <div class="img"><div class="background" :style="{'background-image' : 'url(\'/games/static/miniatures/' + unJeu.image_url + '\')'}"></div></div>
                                <div class="contenu">
                                    <p>{{ unJeu.title }}</p>
                                    <span>Joué {{ unJeu.view_count }} fois</span>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </section>

            <div class="ad-banner">
                <ins class="adsbygoogle"
                data-ad-client="ca-pub-2512331316053279"
                data-ad-slot="6346220535"></ins>
            </div>
        </main>
    </template>
    <template v-else>
        <SkeletonCategorie />
    </template>
</template>

<script>
import SkeletonCategorie from '../components/SkeletonCategorie.vue';
import AddGoogleScripts from '../mixins/addGoogleScripts';

export default {
    name: 'Categorie',
    mixins: [AddGoogleScripts],
    components: {
        SkeletonCategorie
    },
    data() {
        return {
            nowDate: null,

            nbRequests: 0,
            lesJeux: [],

            id: '',
            libelle: '',
            
            formData: null,

            metas : {
                title: 'Jeux gratuits en ligne - Games™ par ClickTestCPS',
                meta: [
                    {
                        name: 'description',
                        content: 'Jouez à des centaines de jeux en ligne sur Games™ par ClickTestCPS.fr ! Une sélection unique de jeux en ligne gratuits alimentée quotidiennement. Jeux de Clickers, Jeux d’Action, Jeux de Réflexion ou encore Jeux de Course, vous pouvez être sûr que vous trouverez votre bonheur ici.'
                    },
                    {
                        name: 'keywords',
                        content: 'ClickTestCPS.fr games, ClickTestCPS games, Jeux clicktestcps, catégorie ClickTestCPS, Catégories jeux clicktestcps.fr, Jeux de Clickers, Jeux d’action, Jeux de réflexion, Jeux de course'
                    },
                    {
                        property: 'og:image',
                        content: 'https://clicktestcps.fr/og-games.png'
                    },
                    {
                        property: 'og:title',
                        content: 'Jeux en ligne gratuits en un clic - Jeu FR '+new Date().getFullYear()+' sans inscription - Games™ par ClickTestCPS'
                    },
                    {
                        property: 'og:description',
                        content: 'Jouez à des centaines de jeux en ligne gratuitement et sans inscription. Une sélection unique de jeux en ligne gratuits alimentée quotidiennement'
                    }
                ]
            }
        }
    },
    mounted() {
        useHead(this.metas);

        this.$store.commit('setRequestTrue');
        
        this.formData = new FormData();
        this.formData.append('data', JSON.stringify({post: "1"}));

        this.getCategory();

        this.nowDate = new Date().getTime()/1000;
    },
    methods: {
        setMetas() {
            let description = '';
            let keywords = '';

            let currentYear = new Date().getFullYear();

            switch(this.libelle) {
                case 'Clickers':
                    description = 'Jouez aux meilleurs jeux gratuits pour mettre à profit votre rapidité à cliquer et votre précision à la souris ! Jeux de Clickers et d’Aim '+currentYear+'.';

                    keywords = 'ClickTestCPS.fr games, ClickTestCPS games, Jeux clicktestcps, Clicker clicktestcps, jeux de clickers, jeu clic solitaire, jeux de clique, jeux de click de souris, jeux point and click, jeux vitesse de clique';
                    break;
                case 'Réflexion':
                    description = 'Défiez votre cerveau et votre intelligence avec nos superbes jeux de réflexion en ligne '+currentYear+'. Découvrez des jeux ingénieux pour petits et grands !';

                    keywords = 'ClickTestCPS.fr games, ClickTestCPS games, Jeux clicktestcps, jeux de réflexion clicktestcps, Jeux de Réflexion, jeux de QI, jeux de réflexion, jeux de réflexion et de logique, jeux de réflexion gratuit pour adulte, jeux de réflexion gratuit sans inscription, jeux de réflexion pc';
                    break;
                case 'Action':
                    description = 'Faites le plein de sensations fortes avec notre sélection de jeux d’action '+currentYear+' ! Des jeux de combats, des jeux de FPS, des jeux d’aventure, des jeux agressifs et puissants, et bien plus encore.';

                    keywords = "ClickTestCPS.fr games, ClickTestCPS games, Jeux clicktestcps, jeux d’action clicktestcps, Jeux d’action, Jeux d’action PC, jeux d’action d'aventure, jeux d’action multijoueur.";
                    break;
                case 'Course':
                    description = 'Prenez les commandes de véhicules surpuissants dans notre sélection unique des meilleurs jeux de course en voiture, moto ou encore camion '+currentYear+'.';

                    keywords = 'ClickTestCPS.fr games, ClickTestCPS games, Jeux clicktestcps, jeux de course clicktestcps, Voiture puissante jeux, Jeux course pc, jeux en ligne voiture, jeux en ligne parking, jeux en ligne moto, jeux en ligne cross, jeux en ligne camion, jeux en ligne scooter, jeux de course à pied, jeux de course de voiture, jeux de voiture foot rocket league, jeux de simulation de voiture, jeux de voiture à deux';
                    break;
            }

            let prefixe = this.libelle.startsWith('A') ? "d'" : "de ";
            this.metas.title = 'Jeux ' + prefixe + this.libelle +' gratuits en ligne - Games™ par ClickTestCPS';
            
            this.metas.meta[0].content = description;
            this.metas.meta[1].content = keywords;
        },
        getCategory() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                categoryName: this.$route.params.categoryName
            }));

            axios
            .post(this.$store.state.apiUrl+"?request=getCategory", formData)
            .then((response) => {
                if(response.data.id) {
                    this.id = response.data.id;
                    this.libelle = response.data.libelle;
                    
                    this.setMetas();
                    this.getCategorieGames();
                }
                else {
                    this.$router.push('/');
                }
            })
            .finally(() => {
                this.nbRequests++;
            });
        },
        getCategorieGames() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                id: this.id
            }));
            
            axios
            .post(this.$store.state.apiUrl+"?request=getCategoryGames", formData)
            .then((response) => {
                if(response.data.length > 0) {
                    this.lesJeux = response.data;
                }
            })
            .finally(() => {
                this.nbRequests++;
            });
        }
    },
    watch: {
        nbRequests() {
            if(this.nbRequests == 2) {
                this.$store.commit('setRequestFalse');
            }
        }
    }
}
</script>

<style scoped src="@/assets/categorie.css">
</style>
